/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTimeline = createReactComponent("timeline", "IconTimeline", [
  ["path", { d: "M4 16l6 -7l5 5l5 -6", key: "svg-0" }],
  ["path", { d: "M15 14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-1" }],
  ["path", { d: "M10 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-2" }],
  ["path", { d: "M4 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-3" }],
  ["path", { d: "M20 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-4" }]
]);

export { IconTimeline as default };
//# sourceMappingURL=IconTimeline.js.map
